export const ReportQueryKeys = {
  all: () => ["reports"],
  single: (reportId: string) => [...ReportQueryKeys.all(), reportId],
  customerReports: (customerId: string) => [...ReportQueryKeys.all(), "customer", customerId],
  reportCustomerLinks: (reportId: string) => [...ReportQueryKeys.all(), reportId, "customer-links"],
};
